import CoalizioniColori from '@/data/coalizioni-colori.json';

export const getCoalitionColor = (cod_coal: number) => {
  return (
    CoalizioniColori.find(c => c.cod_coal === cod_coal.toString())?.colore ||
    '#D9D9D9'
  );
};

export const getCoalitionPosition = (cod_coal: number) => {
  const res = CoalizioniColori.find(c => c.cod_coal === cod_coal.toString());
  if (res !== undefined && res !== null) {
    return res.posizione;
  }
  return 99;
};
